module.exports = __webpack_public_path__ + "img/小狗-1.021749f7.png";